import RichTextEditor from '../../RichTextEditor.jsx';
import React, { useEffect } from 'react';
import OptionToggle from '~/components/OptionToggle.jsx';
import TextInput from '~/components/TextInput';

const EditTextForm = ({ settings, setSettings }) => {
    return (
        <div>
            <div className="panel p-4 mt-4">
                <OptionToggle
                    value={!!settings?.numeric}
                    onChange={value =>
                        setSettings({ ...settings, numeric: value })
                    }
                    title="Numeric"
                    description="Require clients enter a number"
                />
            </div>

            {!!settings?.numeric && (
                <div className="mt-4">
                    <TextInput
                        label="Minimum Value"
                        type="number"
                        value={settings?.min || ''}
                        onChange={value =>
                            setSettings({ ...settings, min: value })
                        }
                    />
                    <TextInput
                        label="Maximum Value"
                        type="number"
                        className="mt-4"
                        value={settings?.max || ''}
                        onChange={value =>
                            setSettings({ ...settings, max: value })
                        }
                    />
                </div>
            )}
        </div>
    );
};

export default EditTextForm;
